module.exports = __webpack_public_path__ + "static/img/COVER-9.75878de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/COVER-9.png
// module id = oIhp
// module chunks = 31